import { DraftWaypointStatus } from '@caresend/types';
import { initTimeZoneDate } from './date.js';
import { generateID } from './id.js';
import { idArrayToObjBool } from '../languageExtensions/array.js';
import 'lodash-unified';

const initDraftWaypoint = (procedureIDs, draftOrderID, officeID) => Object.assign(Object.assign(Object.assign({
  creationTimestamp: Date.now()
}, !!draftOrderID && {
  draftOrderID
}), {
  id: generateID(),
  procedures: Object.assign({}, !!procedureIDs && idArrayToObjBool(procedureIDs)),
  dateOptions: [],
  status: DraftWaypointStatus.PENDING
}), !!officeID && {
  officeID
});
const initDraftWaypointDateInfo = (price, timeZone, timestamp) => ({
  date: initTimeZoneDate(timeZone, timestamp),
  price
});

export { initDraftWaypoint, initDraftWaypointDateInfo };
